import React from "react";
import styles from "./privacypolicypage.module.css";
import HeaderPage from "../../components/HeaderPage";

export default function PrivacyPolicyPage() {
  return (
    <div>
      <HeaderPage />
      <div className={styles.container}>
        <main className={styles.main}>
          <section className={styles.section}>
            <p>
              We collect your personal information in order to provide and
              continually improve our products and services.
            </p>
          </section>

          <section className={styles.section}>
            <h2>Types of Personal Information We Collect</h2>
            <h3>Information You Give Us</h3>
            <p>
              We receive and store any information you provide in relation to
              bHive services. You can choose not to provide certain information,
              but then you might not be able to take advantage of many of our
              services.
            </p>

            <h3>Automatic Information</h3>
            <p>
              We automatically collect and store certain types of information
              about your use of bHive services, including your interaction with
              content and services available through our website. Like many
              websites, we use "cookies" and other unique identifiers to obtain
              certain types of information when your web browser or device
              accesses bHive services.
            </p>

            <h3>Information from Other Sources</h3>
            <p>
              We might receive information about you from other sources, such as
              updated delivery and address information from our carriers, which
              we use to correct our records and deliver your next purchase more
              easily.
            </p>
          </section>

          <section className={styles.section}>
            <h2>Purposes of Using Personal Information</h2>
            <ul>
              <li>
                <strong>Purchase and delivery of products and services:</strong>{" "}
                We use your personal information to take and handle orders,
                deliver products and services, process payments, and communicate
                with you about orders, products, services, and promotional
                offers.
              </li>
              <li>
                <strong>Provide, troubleshoot, and improve services:</strong> We
                use your personal information to provide functionality, analyze
                performance, fix errors, and improve the usability and
                effectiveness of our services.
              </li>
              <li>
                <strong>Recommendations and personalization:</strong> We use
                your personal information to recommend features, products, and
                services that might be of interest to you, identify your
                preferences, and personalize your experience.
              </li>
              <li>
                <strong>Comply with legal obligations:</strong> In certain
                cases, we collect and use your personal information to comply
                with laws.
              </li>
              <li>
                <strong>Communicate with you:</strong> We use your personal
                information to communicate with you in relation to bHive
                services via different channels (e.g., by phone, email, chat).
              </li>
              <li>
                <strong>Advertising:</strong> We use your personal information
                to display interest-based ads for features, products, and
                services that might be of interest to you.
              </li>
              <li>
                <strong>Fraud prevention and credit risks:</strong> We use
                personal information to prevent and detect fraud and abuse in
                order to protect the security of our customers, bHive, and
                others. We may also use scoring methods to assess and manage
                credit risks.
              </li>
            </ul>
          </section>

          <section className={styles.section}>
            <h2>Cookies and Other Identifiers</h2>
            <p>
              To enable our systems to recognize your browser or device and to
              provide and improve bHive services, we use cookies and other
              identifiers.
            </p>
          </section>

          <section className={styles.section}>
            <h2>Does bHive Share Your Personal Information?</h2>
            <p>
              Information about our customers is an important part of our
              business, and we are not in the business of selling our customers'
              personal information to others. We share customers' personal
              information only as described below and with subsidiaries bHive
              controls that either are subject to this Privacy Notice or follow
              practices at least as protective as those described in this
              Privacy Notice.
            </p>

            <h3>Transactions Involving Third Parties</h3>
            <p>
              We make available to you services, products, applications, or
              skills provided by third parties for use on or through bHive
              services.
            </p>

            <h3>Third-Party Service Providers</h3>
            <p>
              We employ other companies and individuals to perform functions on
              our behalf. These third-party service providers have access to
              personal information needed to perform their functions, but may
              not use it for other purposes.
            </p>

            <h3>Business Transfers</h3>
            <p>
              As we continue to develop our business, we might sell or buy other
              businesses or services. In such transactions, customer information
              generally is one of the transferred business assets.
            </p>

            <h3>Protection of bHive and Others</h3>
            <p>
              We release account and other personal information when we believe
              release is appropriate to comply with the law; enforce or apply
              our Conditions of Use and other agreements; or protect the rights,
              property, or safety of bHive, our users, or others.
            </p>
          </section>

          <section className={styles.section}>
            <h2>How Secure Is My Information?</h2>
            <p>
              We design our systems with your security and privacy in mind. We
              work to protect the security of your personal information during
              transmission by using encryption protocols and software. We
              maintain physical, electronic, and procedural safeguards in
              connection with the collection, storage, and disclosure of
              customer personal information.
            </p>
          </section>

          <section className={styles.section}>
            <h2>What Choices Do I Have?</h2>
            <p>
              If you have any questions as to how we collect and use your
              personal information, please contact our Customer Service. Many of
              our services also include settings that provide you with options
              as to how your information is being used.
            </p>
          </section>

          <section className={styles.section}>
            <h2>Children's Privacy</h2>
            <p>
              bHive does not sell products for purchase by children. We sell
              children's products for purchase by adults. If you are under 18,
              you may use bHive services only with the involvement of a parent
              or guardian.
            </p>
          </section>

          <section className={styles.section}>
            <h2>Conditions of Use, Notices, and Revisions</h2>
            <p>
              If you choose to use bHive services, your use and any dispute over
              privacy is subject to this Notice and our Conditions of Use,
              including limitations on damages, resolution of disputes, and
              application of the law of the state in which we are based. If you
              have any concern about privacy at bHive, please contact us with a
              thorough description, and we will try to resolve it.
            </p>

            <p>
              Our business changes constantly, and our Privacy Notice will
              change also. You should check our website frequently to see recent
              changes. Unless stated otherwise, our current Privacy Notice
              applies to all information that we have about you and your
              account.
            </p>
          </section>
        </main>
        <footer className={styles.footer}>
          <p>
            If you have any questions about this Privacy Policy, please contact
            us at <a href="mailto:support@bhive.com">support@bhive.com</a>.
          </p>
        </footer>
      </div>
    </div>
  );
}
